import {memo} from "react";

import {BinIcon} from "../../../../components/icon/Icon";
import {
    DocumentCheckCardContainerStyled,
    DocumentCheckErrorBackground,
    DocumentCheckSignStyled
} from "./styled/DocumentCheckCardStyled";

export const DocumentCheckCard = memo(({ children, error }) => (
    <DocumentCheckCardContainerStyled>
        {children}
        <DocumentCheckSignStyled>
            <BinIcon
                    name={error ? 'IcXCircle' : 'IcCheckMarkCircle'}
                    style={{fill: error ? 'var(--color-red)' : 'var(--color-green-secondary)'}}
            />
        </DocumentCheckSignStyled>
        {error && <DocumentCheckErrorBackground/>}
    </DocumentCheckCardContainerStyled>
));